// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17FCf","title":"styles_title__S1UdV"};